import style from './TopCams.module.less';
import PropTypes from 'prop-types';
import TranslationHelper from '../../utils/TranslationHelper.js';
import FormCheckbox from '../Form/FormCheckbox.js';
import Translations from '../../utils/Translations.js';

const Header = (props) => {
	if (props.isVideocall) {
		return (
			<div className={style.headerBannerBackground}>
				<div className={`${style.headerBannerContainer} ${props.showDescription ? style.visible : style.hidden}`}>
					<img className={style.headerBannerImage} src={props.bannerImage} />
					{props.isMobile && <i className={style.bannerClose + ' icon -icon-close-full'} onClick={() => props.setShowDescription(false)} />}
					<div className={style.headerBannerContent}>
						<div className={style.headerBannerText}>
							<div className={style.headerBannerTitle}>
								{props.text.split(' ').map((word, index) =>
									index === 1 ? (
										<span className={style.highlight} key={index}>
											{word}{' '}
										</span>
									) : (
										<span key={index}>{word} </span>
									),
								)}
								{props.isMobile && <img src="../../../assets/img/topLists/hey.svg" className={style.headerBannerBadge} />}
							</div>
							<div className={style.headerBannerDescription}>{TranslationHelper.parseDescriptionText(props.subText)}</div>
						</div>
						{props.onlineModels.length > 0 && !props.isMobile && (
							<div className={style.headerBannerInfo}>
								<i className={style.headerBannerInfoIcon + ' icon -icon-live-full ' + style.pulseWhite} />
								{props.onlineModels.length} Online
								<div className={style.headerBannerInfoActors}>
									{props.onlineModels.slice(0, Math.min(4, props.onlineModels.length)).map((model, index, visibleModels) => {
										const remainingCount = props.onlineModels.length - 4;
										const showRemainingBadge = index === visibleModels.length - 1 && index === 3 && remainingCount > 0;
										return (
											<div
												key={model.id || index}
												className={style.headerBannerInfoActorWrapper}
												style={{ zIndex: props.onlineModels.length - index }}
											>
												<img className={style.headerBannerInfoActor} src={model.avatarPicture} alt="" />
												{showRemainingBadge && <div className={style.headerBannerInfoActorCount}>+{remainingCount}</div>}
											</div>
										);
									})}
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className={`${style.headerContainer} ${props.showDescription ? style.visible : style.hidden}`}>
			<div className={style.headerTitle}>
				<span>
					{props.text}
					{props.infoText && !props.isMobile && <span className={style.headerInfo}> / {props.infoText}</span>}
				</span>
				{props.isMobile && <i className={style.headerClose + ' icon -icon-close-full'} onClick={() => props.setShowDescription(false)} />}
				{props.showOnlinefilter && !props.isMobile && (
					<FormCheckbox
						name="filterOnline"
						label={Translations.get('MessengerShowOnlyOnline')}
						checked={props.filterChecked}
						onValueChange={props.onChangeFn}
						labelClassName="h-color-fg-description"
					/>
				)}
			</div>
			{props.subText && <div className={style.headerDescription}>{TranslationHelper.parseDescriptionText(props.subText)}</div>}
		</div>
	);
};

export default Header;

Header.propTypes = {
	text: PropTypes.string.isRequired,
	infoText: PropTypes.string,
	subText: PropTypes.string.isRequired,
	isMobile: PropTypes.bool,
	showDescription: PropTypes.bool,
	setShowDescription: PropTypes.func,
	isVideocall: PropTypes.bool,
	bannerImage: PropTypes.string,
	onlineModels: PropTypes.array,
	filterChecked: PropTypes.bool,
	onChangeFn: PropTypes.func,
	showOnlinefilter: PropTypes.bool,
};

Header.defaultProps = {
	isMobile: false,
	isVideocall: false,
	showOnlinefilter: true,
};
